import { observable, action } from 'mobx';
import { IApiService } from '../services/IApiService';
import FakturacniSubjekt from '../models/FakturacniSubjekt';
import Faktura from 'src/models/Faktura';
import FakturaceNahled from "../models/FakturaceNahled";

export default class FakturaceStore {
    public subjects: FakturacniSubjekt[] = [];
    @observable public availableSubjects: FakturacniSubjekt[] = [];
    @observable public subjectsByKlientID: Map<number, FakturacniSubjekt[]> = new Map();

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public loadAvailableSubjects(): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getAvailableSubjects().then(subjekty => {
                subjekty.forEach(subjekt => {
                    this.availableSubjects.push(subjekt);
                });
                resolve(true);
            });
        })
    }

    public loadFakturacniSubjektyAll(): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getFakturacniSubjektyAll().then(subjekty => {
                subjekty.forEach(subjekt => {
                    this.addSubjekt(subjekt);
                });
                resolve(true);
            });
        })
    }

    public addSubjekt(subjekt: FakturacniSubjekt) {
        if(this.subjectsByKlientID.has(subjekt.idKlient)) {
            this.subjectsByKlientID.get(subjekt.idKlient).push(subjekt);
        } else {
            this.subjectsByKlientID.set(subjekt.idKlient, []);
            this.subjectsByKlientID.get(subjekt.idKlient).push(subjekt);
        }
        this.subjects.push(subjekt);
    }

    public removeSubjekt(subjekt: FakturacniSubjekt) {
        if(this.subjectsByKlientID.has(subjekt.idKlient)) {
            const subjekty = this.subjectsByKlientID.get(subjekt.idKlient);

            const index = subjekty.findIndex(a => a.id === subjekt.id);
            if(index >= 0) {
                subjekty.splice(index, 1);
            }
            
            if(subjekty.length < 1) {
                this.subjectsByKlientID.delete(subjekt.idKlient);
            }
        }

        const indexGeneral = this.subjects.findIndex(a => a.id === subjekt.id);
        if(indexGeneral >= 0) {
            this.subjects.splice(indexGeneral, 1);
        }
    }

    public refreshSubjects(): Promise<boolean> {
        this.subjects = [];
        this.subjectsByKlientID = new Map();
        return this.loadFakturacniSubjektyAll();
    }

    public addNewSubjekt(subjekt: FakturacniSubjekt): Promise<FakturacniSubjekt> {
        return new Promise(resolve => {
            this.api.addFakturacniSubjekt(subjekt).then(newSubjekt => {
                this.addSubjekt(newSubjekt);
                resolve(newSubjekt);
            })
        });
    }

    public removeExistingSubject(subjekt: FakturacniSubjekt): Promise<boolean> {
        return new Promise(resolve => {
            this.api.removeFakturacniSubjekt(subjekt).then(success => {
                this.removeSubjekt(subjekt);
                resolve(success);
            });
        });
    }

    public getInvoicePreview(orderId: number): Promise<FakturaceNahled> {
        return this.api.getFakturaNahledByOrderID(orderId);
    }

    public getSubjektyByKlientID(clientId: number): FakturacniSubjekt[] {
        if(this.subjectsByKlientID.has(clientId)) {
            return this.subjectsByKlientID.get(clientId);
        }
        return [];
    }

    public getSubjectByFakturoidID(fakturoidID: number): FakturacniSubjekt {
        return this.subjects.find(sub => sub.idSubjekt === fakturoidID);
    }

    public createInvoice(objednavkaId: number, subjektId: number, price: number): Promise<Faktura> {
        const retVal: Faktura = new Faktura();
        retVal.price = price;
        retVal.idSubjekt = subjektId;
        retVal.idObjednavka = objednavkaId;
        return this.api.createNewInvoice(retVal);
    }

    public getInvoicesForOrder(orderID: number): Promise<Faktura[]> {
        return this.api.getFakturyByOrderID(orderID);
    }
}



// WEBPACK FOOTER //
// ./src/stores/FakturaceStore.tsx